module.exports = __webpack_public_path__ + "img/Dunkin_Donuts_logo.e8148bbc.svg";